module.exports = __webpack_public_path__ + "static/media/27-4.e16e3326.mp3";